import { ContactHeroSlice } from "prismicio-types";
import { withConfigure } from "hyam-core/utils/withConfigure";
import { styles as moduleStyles, S01ContactHeroDefaultStyles } from "./styles";
import { HyamPrismicLink } from "hyam-prismic/components/elements";
import cn from "classnames";

export type S01ContactHeroDefaultProps = {
  slice: ContactHeroSlice;
  index: number;
  styles?: Partial<S01ContactHeroDefaultStyles>;
  stylesReplace?: Partial<S01ContactHeroDefaultStyles>;
};

const _S01ContactHeroDefault = (props: S01ContactHeroDefaultProps) => {
  const { slice } = props;
  const items = slice.items;
  const styles = props.styles as S01ContactHeroDefaultStyles;

  return (
    <section className={styles.container}>
      <div className="h-fit fixed inset-0 m-auto flex flex-col xl:flex-row items-center w-fit gap-24 md:gap-28">
        {items.map((link, i) => {
          return (
            <HyamPrismicLink
              key={i}
              className={cn(
                "decoration-transparent hover:decoration-black transition-all duration-300 underline underline-offset-[5px] decoration-2 font-display text-[32px] md:text-[45px] xl:text-[3vw] 2xl:text-[50px] whitespace-nowrap uppercase ",
              )}
              field={link?.link}
            >
              {link?.text}
            </HyamPrismicLink>
          );
        })}
      </div>
    </section>
  );
};

export const S01ContactHeroDefault = withConfigure<
  S01ContactHeroDefaultProps,
  S01ContactHeroDefaultStyles
>({
  componentName: "S01ContactHeroDefault",
  Component: _S01ContactHeroDefault,
  moduleStyles,
});
